document.addEventListener('click', function(e) {
  const btn = e.target.closest('.size-button');
  if (!btn || btn.disabled) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  // Añadir al carrito via API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(() => {
    // Abrir carrito lateral (drawer)
    // Tu tema usa uno de estos — prueba en orden:
    document.dispatchEvent(new CustomEvent('cart:open'));         // opción 1
    document.querySelector('[data-cart-drawer]')?.classList.add('is-open'); // opción 2
    document.querySelector('cart-drawer')?.open?.();             // opción 3

    // Actualizar contador del carrito
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counters = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
        counters.forEach(el => el.textContent = cart.item_count);
      });
  })
  .catch(err => console.error('Error añadiendo al carrito:', err));
});